import React from 'react';
import VgsInputLabel from './VgsInput/VgsInputLabel';
import RawDisplayValue from './RawValueDisplay';
import JsonTokenDisplay from './JsonTokenDisplay';

function DisplayItem({
  value,
  label,
  token,
}: {
  value: unknown;
  label: string;
  token: string;
}): React.JSX.Element {
  if (`${value}`.startsWith('tok')) {
    return <JsonTokenDisplay token={`${value}`} label={label} />;
  } else if (typeof value === 'object') {
    return (
      <li>
        <JsonDisplayValue value={value} token={token} label={label} />
      </li>
    );
  } else {
    return (
      <li>
        <RawDisplayValue
          value={value}
          label={label}
          useFieldStyling={true}
          scrollY={true}
        />
      </li>
    );
  }
}

export default function JsonDisplayValue({
  value,
  label,
  token,
}: {
  value: unknown;
  label: string;
  token: string;
}): React.JSX.Element {
  let listItems: React.JSX.Element[] = [];
  if (Array.isArray(value)) {
    listItems = value.map(
      (value, index): React.JSX.Element => (
        <DisplayItem token={token} value={value} label={''} key={index} />
      ),
    );
  } else if (value !== null && typeof value === 'object') {
    const entries =
      value !== null && typeof value === 'object'
        ? Object.entries(value as { [s: string]: unknown })
        : [];
    listItems = entries.map(
      ([key, value], index): React.JSX.Element => (
        <DisplayItem token={token} value={value} label={key} key={index} />
      ),
    );
  }
  return (
    <div>
      <VgsInputLabel label={label} required={false} />
      <ul className='ml-5'>{listItems}</ul>
    </div>
  );
}
